import { OverlayTrigger } from "react-bootstrap";
import Tooltip from 'react-bootstrap/Tooltip';
import './tooltip.sass';

export default function BaseTooltip (props) {
    const { placement = 'bottom', body = '', children, ...rest } = props;

    return (
        <OverlayTrigger
            placement={placement}
            overlay={props => <Tooltip id={`tooltip-${placement}`} {...props}>{body}</Tooltip>}
            {...rest}
        >
            {children}
        </OverlayTrigger>
    )
}
